// One selected index controls the stage, both text areas and the purchase link.
class FaunivaBundleShowroom {
  constructor(root) {
    this.root = root;
    this.cards = [...root.querySelectorAll('[data-bundle-card]')];
    this.selectors = [...root.querySelectorAll('[data-bundle-select]')];
    this.copies = [...root.querySelectorAll('[data-bundle-copy]')];
    this.details = [...root.querySelectorAll('[data-bundle-details]')];
    this.status = root.querySelector('[data-bundle-status]');
    this.stage = root.querySelector('[data-bundle-stage]');
    this.cleanup = new AbortController();
    const listen = (el, type, fn, options = {}) => el?.addEventListener(type, fn, { ...options, signal: this.cleanup.signal });
    this.cards.forEach((el,i) => listen(el,'click',event => {
      if (el.tagName !== 'A') {
        event.preventDefault(); this.select(i);
      }
    }));
    this.imageToggles = [...root.querySelectorAll('[data-bundle-image-toggle]')];
    this.imageToggles.forEach(el => listen(el,'click',() => {
      const card = this.cards[Number(el.dataset.bundleImageToggle)];
      const alternate = card?.classList.toggle('is-alternate');
      el.setAttribute('aria-pressed', String(Boolean(alternate)));
    }));
    this.selectors.forEach((el,i) => {
      listen(el,'click',() => this.select(i));
      listen(el.closest('.fauniva-bundles__pill'),'click',event => {
        if (!event.target.closest('a, [data-bundle-select]')) this.select(i);
      });
    });
    listen(root.querySelector('[data-bundle-prev]'),'click',() => this.step(-1));
    listen(root.querySelector('[data-bundle-next]'),'click',() => this.step(1));
    listen(root,'keydown',event => {
      if (!event.target.closest('.fauniva-bundles__controls, [data-bundle-stage]')) return;
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const i = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowLeft' ? -1 : 1);
      this.select(i);
      this.selectors[this.index]?.focus({ preventScroll: true });
    });
    let start = null;
    listen(this.stage,'pointerdown',event => { if(event.isPrimary && event.button === 0) start = {x:event.clientX,y:event.clientY}; });
    listen(this.stage,'pointercancel',() => {start=null;});
    listen(this.stage,'pointerup',event => {
      if (!start) return;
      const dx = event.clientX-start.x, dy = event.clientY-start.y;start=null;
      if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.3) {
        this.suppressClick=true;this.step(dx<0?1:-1);
        setTimeout(() => {this.suppressClick=false;},300);
      }
    });
    listen(this.stage,'click',event => { if(this.suppressClick){event.preventDefault();event.stopImmediatePropagation();} },{capture:true});
    let wheelTotal=0, lastWheel=0;
    listen(this.stage,'wheel',event => {
      // A vertical page scroll always continues normally.
      if(Math.abs(event.deltaX)<Math.abs(event.deltaY)*1.25 || Math.abs(event.deltaX)<2) return;
      event.preventDefault();
      const now=performance.now();if(now-lastWheel>220) wheelTotal=0;
      wheelTotal+=event.deltaX;
      if(Math.abs(wheelTotal)>60 && now-lastWheel>450){this.step(wheelTotal>0?1:-1);lastWheel=now;wheelTotal=0;}
    },{passive:false});
    const catalog=root.querySelector('.fauniva-bundles__catalog');
    const openCatalog=() => {if(location.hash==='#all-bundles' && catalog) catalog.open=true;};
    listen(root.querySelector('.fauniva-bundles__all'),'click',event => {
      if(event.currentTarget.getAttribute('href')==='#all-bundles' && catalog) catalog.open=true;
    });
    listen(window,'hashchange',openCatalog);openCatalog();
    this.select(Math.max(0,this.cards.findIndex(el=>el.dataset.bundleCode===root.dataset.defaultBundle)),false);
    root.dataset.bundleEnhanced = 'true';
  }
  step(delta){this.select(this.index+delta);}
  select(index,announce=true){
    if(!this.cards.length)return;
    this.index=(index+this.cards.length)%this.cards.length;
    this.cards.forEach((el,i)=>{
      const active=i===this.index;
      el.classList.toggle('is-active',active);
      if (el.tagName === 'A') {
        if (active) el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current');
      } else el.setAttribute('aria-pressed',String(active));
      if (!active) el.classList.remove('is-alternate');
      const previous = i === (this.index - 1 + this.cards.length) % this.cards.length;
      const next = i === (this.index + 1) % this.cards.length;
      const visible = active || previous || next;
      el.dataset.position = active ? 'center' : next ? 'right' : previous ? 'left' : 'away';
      el.hidden = !visible;
      el.setAttribute('aria-hidden', String(!visible));
      el.tabIndex = visible ? 0 : -1;
    });
    this.selectors.forEach((el,i)=>{el.classList.toggle('is-active',i===this.index);el.setAttribute('aria-pressed',String(i===this.index));el.closest('.fauniva-bundles__pill')?.classList.toggle('is-active',i===this.index);});
    this.imageToggles.forEach(el=>{el.hidden=Number(el.dataset.bundleImageToggle)!==this.index;el.setAttribute('aria-pressed',String(this.cards[this.index]?.classList.contains('is-alternate')));});
    [...this.copies,...this.details].forEach(el=>{
      const i=Number(el.dataset.bundleCopy ?? el.dataset.bundleDetails);
      el.hidden=i!==this.index;el.classList.toggle('is-active',i===this.index);
    });
    if(announce && this.status) this.status.textContent=this.details[this.index]?.textContent.trim().replace(/\s+/g,' ') || '';
  }
  destroy(){this.cleanup.abort();delete this.root.dataset.bundleEnhanced;}
}
const showroomInstances=new Map();
const mountShowrooms=(root=document)=>{
  const roots=[...(root.matches?.('[data-bundle-showroom]')?[root]:[]),...root.querySelectorAll('[data-bundle-showroom]')];
  roots.forEach(el=>{if(!showroomInstances.has(el))showroomInstances.set(el,new FaunivaBundleShowroom(el));});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mountShowrooms(),{once:true});else mountShowrooms();
document.addEventListener('shopify:section:load',event=>mountShowrooms(event.target));
document.addEventListener('shopify:section:unload',event=>{
  for(const [el,instance] of showroomInstances){if(event.target.contains(el)){instance.destroy();showroomInstances.delete(el);}}
});


